import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from "crypto-js";
import * as moment from "moment";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import {
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-addinquiry",
  templateUrl: "./addinquiry.component.html",
  styleUrls: ["./addinquiry.component.css"],
})
export class AddinquiryComponent implements OnInit {
  isDisabled: boolean = false;
  permission: any;
  userRId: any;
  ReceiveDate: number = 0;
  disableDate() {
    return false;
  }
  activitytype: any = "activity";
  registerForm1: FormGroup;
  registerForm2: FormGroup;
  submitted = false;
  userid: any;
  InquiryId: number = 0;
  id: any;
  showProjectArray: any = [];
  showInquiryArray: any = [];
  showCustomerArray: any = [];
  showContractorArray: any = [];
  showMainContractorArray: any = [];
  showConsultantArray: any = [];
  showSupervisionArray: any = [];
  showStageArray: any = [];
  showProbabilityArray: any = [];
  showQuotationErArray: any = [];
  showSalesErArray: any = [];
  businessVerticalArray: any = [];
  showcategoryArray: any = [];
  showReasonArray: any = [];
  showRevisionArray: any = [];
  showProjectSourceArray: any = [];
  showTerritoryArray: any = [];

  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSetting8: any = {};
  dropdownSetting9: any = {};
  dropdownSetting10: any = {};
  dropdownSetting11: any = {};
  dropdownSetting12: any = {};
  dropdownSetting13: any = {};
  dropdownSetting14: any = {};
  dropdownSetting15: any = {};
  dropdownSetting16: any = {};
  dropdownSetting17: any = {};

  InqNameId: Observable<string[]>;
  ProNameId: Observable<string[]>;
  optionsIqr: string[] = [];
  optionsPro: string[] = [];

  showRevision = {};
  createdInquiryId: void;
  encryptInquiryId: string;
  Revision: number = 0;
  ReceivedDate: string = "";
  ReceivedDate2: string = "";
  maxDate: any;
  minDate: any;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private UserService: UserService,
    calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
    this.maxDate = new Date();
    this.minDate = new Date();
    let mnd = new Date(this.minDate);
    this.minDate.setDate(mnd.getDate() - 30);
    this.receiveDate();
  }

  ngOnInit(): void {
    this.activitytype = "activity";
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Inquiry_Add != 1 && this.userRId != 1) {
      this.toastrService.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);

    this.getproject();
    this.getsource();
    this.getterritory();
    this.getcustomer();
    this.getstage();
    this.getprobability();
    this.getquotationEr();
    this.getsalesEr();
    this.getBusinessVertical();
    this.getreason();

    this.registerForm1 = this.formBuilder.group({
      ProjectId: ["", Validators.required],
      InquiryId: [""],
      InquiryName: ["", Validators.required],
      CustomerName: ["", Validators.required],
      MEPContractor: [""],
      MainContractor: [""],
      DesignConsultant: [""],
      SupervisionConsultant: [""],
      StageId: ["", Validators.required],
      InquiryProbability: ["", Validators.required],
      ReceivedDate: ["", Validators.required],
      QuotationEngineerId: ["", Validators.required],
      SalesEngineerId: ["", Validators.required],
      BusinessVertical: ["", Validators.required],
    });

    this.registerForm2 = this.formBuilder.group({
      ProjectName: ["", Validators.required],
      ProjectSource: ["", Validators.required],
      Territory: ["", Validators.required],
      InquiryId: [""],
      InquiryName: ["", Validators.required],
      CustomerName: ["", Validators.required],
      MEPContractor: [""],
      MainContractor: [""],
      DesignConsultant: [""],
      SupervisionConsultant: [""],
      StageId: ["", Validators.required],
      InquiryProbability: ["", Validators.required],
      ReceivedDate2: ["", Validators.required],
      QuotationEngineerId: ["", Validators.required],
      SalesEngineerId: ["", Validators.required],
      BusinessVertical: ["", Validators.required],
      QuotedValue: [""],
      ReportedValue: [""],
      QuotedDate: [""],
      IncoTerms: [""],
      Application: [""],
      ExpOrderDate: [""],
      LostTo: [""],
      Reason: [""],
      LOIMargin: [""],
      POMargin: [""],
      Revision: [""],
      RevisionNote: [""],
    });

    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Project Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Inquiry Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting3 = {
      singleSelection: true,
      text: "Customer Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting4 = {
      singleSelection: true,
      text: "MEP Contractor",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting5 = {
      singleSelection: true,
      text: "Main Contractor",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting6 = {
      singleSelection: true,
      text: "Design Consultant",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting7 = {
      singleSelection: true,
      text: "Supervision Consultant",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting8 = {
      singleSelection: true,
      text: "Stages",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: false,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting9 = {
      singleSelection: true,
      text: "Probability",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting10 = {
      singleSelection: true,
      text: "Quotation Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting11 = {
      singleSelection: true,
      text: "Sales Engineer",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting12 = {
      singleSelection: true,
      text: "Business Verticals",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting13 = {
      singleSelection: true,
      text: "Business Category",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting14 = {
      singleSelection: true,
      text: "Reason",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.showRevision = [
      { id: 1, itemName: "R01" },
      { id: 2, itemName: "R02" },
      { id: 3, itemName: "R03" },
      { id: 4, itemName: "R04" },
      { id: 5, itemName: "R05" },
    ];

    this.dropdownSetting15 = {
      singleSelection: true,
      text: "Select Status",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownSetting16 = {
      singleSelection: true,
      text: "Project Source",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting17 = {
      singleSelection: true,
      text: "Territory",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      lazyLoading: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
  }

  IqrSearchFun(event) {
    let value1 = event.target.value;
    this.InqNameId = this.registerForm1.controls[
      "InquiryName"
    ].valueChanges.pipe(
      startWith(""),
      map((value: string) => this.filterIqr(value1 || ""))
    );
  }
  private filterIqr(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsIqr.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  ProSearchFun(event) {
    let value1 = event.target.value;
    this.ProNameId = this.registerForm2.controls[
      "ProjectName"
    ].valueChanges.pipe(
      startWith(""),
      map((value: string) => this._filterPro(value1 || ""))
    );
  }
  private _filterPro(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsPro.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get f1() {
    return this.registerForm1.controls;
  }
  get f2() {
    return this.registerForm2.controls;
  }

  receiveDate() {
    let data = {
      PropertyName: "MinReceivedDate",
      ModuleName: "Inquiry",
    };
    this.UserService.GetOptionValue(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ReceiveDate = res["Data"][0]["Value"];
        let mnd = new Date();
        this.minDate = new Date();
        this.minDate.setDate(mnd.getDate() - this.ReceiveDate);
      } else if (res["result"] == "Failed") {
        this.toastrService.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastrService.error(res["Msg"] || res["Message"]);
        this.spinner.hide();
      }
    });
  }

  changeActivityType(type) {
    this.activitytype = type;
  }

  selectedrevision2 = [];
  selectedRevision2: any;
  selectedRevisionId2: number = 0;
  onRevisionSelect2(item: any) {
    this.selectedRevision2 = "";
    this.selectedRevisionId2 = 0;
    this.selectedrevision2.forEach((element) => {
      this.selectedRevision2 = element["itemName"];
      this.selectedRevisionId2 = element["id"];
    });
  }

  showProject: any = [];
  getproject() {
    this.optionsPro = [];
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        for (const projectData of this.showProjectArray["Data"]) {
          if (
            projectData["Status"] == 1 &&
            (projectData["ProjectStatus"] == 4 ||
              projectData["ProjectStatus"] == 6)
          ) {
            const projectItem = {
              id: projectData["ProjectId"],
              itemName:
                projectData["ProjectName"] +
                " (" +
                projectData["ProjectNumber"] +
                ")",
            };
            this.showProject.push(projectItem);
            this.optionsPro.push(projectData["ProjectName"]);
          }
        }
      } else {
        this.showProjectArray = [];
        this.optionsPro = [];
      }
    });
  }
  selectedproject: any = [];
  selectedProject: any;
  selectedProjectId: number = 0;
  onProjectSelect(item: any) {
    this.optionsIqr = [];
    this.selectedProject = "";
    this.selectedProjectId = 0;
    this.selectedproject.forEach((element) => {
      this.selectedProject = element["itemName"];
      this.selectedProjectId = element["id"];
    });

    this.selectedsalesEr = [];
    this.selectedquotationEr = [];
    this.selectedQuotationErId = 0;
    this.selectedSalesErId = 0;
    for (const projectData of this.showProjectArray["Data"]) {
      if (projectData["ProjectId"] == item.id) {
        this.selectedsalesEr.push({
          id: projectData["SalesEngineer"],
          itemName: projectData["SalesEngineerName"],
        });
        this.selectedquotationEr.push({
          id: projectData["QuotationEngineer"],
          itemName: projectData["QuotationEngineerName"],
        });
        this.selectedQuotationErId = projectData["QuotationEngineer"];
        this.selectedSalesErId = projectData["SalesEngineer"];
      }
    }

    this.GetInquiry(this.selectedProjectId);
  }

  GetInquiry(Id: any) {
    this.optionsIqr = [];
    let data = {
      ProjectId: Id,
    };
    this.UserService.GetInquiryNumberByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        res["Data"].forEach((element) => {
          this.optionsIqr.push(element.InquiryName);
        });
      } else {
        this.optionsIqr = [];
      }
    });
  }

  showProjectSource: any = [];
  getsource() {
    let data = {};
    this.UserService.GetProjectSource(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectSourceArray = res;
        this.showProjectSource = [];
        for (const projectSourceData of this.showProjectSourceArray["Data"]) {
          this.showProjectSource.push({
            id: projectSourceData["Id"],
            itemName: projectSourceData["ProjectSource"],
          });
        }
      } else {
        this.showProjectSourceArray = [];
      }
    });
  }
  selectedprojectsource: any = [];
  selectedProjectSource: any;
  selectedProjectSourceId: number = 0;
  onProjectSourceSelect(item: any) {
    this.selectedProjectSource = "";
    this.selectedProjectSourceId = 0;
    this.selectedprojectsource.forEach((element) => {
      this.selectedProjectSource = element["itemName"];
      this.selectedProjectSourceId = element["id"];
    });
  }

  showTerritory: any = [];
  getterritory() {
    let data = {};
    this.UserService.GetTerritory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showTerritoryArray = res;
        this.showTerritory = [];
        for (const territoryData of this.showTerritoryArray["Data"]) {
          this.showTerritory.push({
            id: territoryData["Id"],
            itemName: territoryData["TerritoryName"],
          });
        }
      } else {
        this.showTerritoryArray = [];
      }
    });
  }
  selectedterritory: any = [];
  selectedTerritory: any;
  selectedTerritoryId: number = 0;
  onTerritorySelect(item: any) {
    this.selectedTerritory = "";
    this.selectedTerritoryId = 0;
    this.selectedterritory.forEach((element) => {
      this.selectedTerritory = element["itemName"];
      this.selectedTerritoryId = element["id"];
    });
  }

  showCustomer: any = [];
  showContractor: any = [];
  showMainContractor: any = [];
  showConsultant: any = [];
  showSupervision: any = [];
  getcustomer() {
    let data = {};
    this.UserService.GetAllCustomer(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCustomerArray = res;
        this.showCustomer = [];
        for (const customerData of this.showCustomerArray["CustomerName"]) {
          this.showCustomer.push({
            id: customerData["CompanyId"],
            itemName: customerData["CompanyName"],
          });
        }

        this.showContractorArray = res;
        this.showContractor = [];
        for (const contractorData of this.showContractorArray[
          "MEPContractor"
        ]) {
          this.showContractor.push({
            id: contractorData["CompanyId"],
            itemName: contractorData["CompanyName"],
          });
        }

        this.showMainContractorArray = res;
        this.showMainContractor = [];
        for (const mainContractorData of this.showMainContractorArray[
          "MainContractor"
        ]) {
          this.showMainContractor.push({
            id: mainContractorData["CompanyId"],
            itemName: mainContractorData["CompanyName"],
          });
        }

        this.showConsultantArray = res;
        this.showConsultant = [];
        for (const consultantData of this.showConsultantArray[
          "Designonsultant"
        ]) {
          this.showConsultant.push({
            id: consultantData["CompanyId"],
            itemName: consultantData["CompanyName"],
          });
        }

        this.showSupervisionArray = res;
        this.showSupervision = [];
        for (const supervisionData of this.showSupervisionArray[
          "SupervisionConsultant"
        ]) {
          this.showSupervision.push({
            id: supervisionData["CompanyId"],
            itemName: supervisionData["CompanyName"],
          });
        }
      } else {
        this.showCustomerArray = [];
        this.showContractorArray = [];
        this.showMainContractorArray = [];
        this.showConsultantArray = [];
        this.showSupervisionArray = [];
      }
    });
  }
  selectedcustomer: any = [];
  selectedCustomer: any;
  selectedCustomerId: number = 0;
  onCustomerSelect(item: any) {
    this.selectedCustomer = "";
    this.selectedCustomerId = 0;
    this.selectedcustomer.forEach((element) => {
      this.selectedCustomer = element["itemName"];
      this.selectedCustomerId = element["id"];
    });
  }
  selectedcontractor: any = [];
  selectedContractor: any;
  selectedContractorId: number = 0;
  onContractorSelect(item: any) {
    this.selectedContractor = "";
    this.selectedContractorId = 0;
    this.selectedcontractor.forEach((element) => {
      this.selectedContractor = element["itemName"];
      this.selectedContractorId = element["id"];
    });
  }
  selectedmaincontractor: any = [];
  selectedMainContractor: any;
  selectedMainContractorId: number = 0;
  onMainContractorSelect(item: any) {
    this.selectedMainContractor = "";
    this.selectedMainContractorId = 0;
    this.selectedMainContractor = item.itemName;
    this.selectedMainContractorId = item.id;
  }
  selectedconsultant: any = [];
  selectedConsultant: any;
  selectedConsultantId: number = 0;
  onConsultantSelect(item: any) {
    this.selectedConsultant = "";
    this.selectedConsultantId = 0;
    this.selectedconsultant.forEach((element) => {
      this.selectedConsultant += element["itemName"];
      this.selectedConsultantId += element["id"];
    });
  }
  selectedsupervision: any = [];
  selectedSupervision: any;
  selectedSupervisionId: number = 0;
  onSupervisionSelect(item: any) {
    this.selectedSupervision = "";
    this.selectedSupervisionId = 0;
    this.selectedsupervision.forEach((element) => {
      this.selectedSupervision += element["itemName"];
      this.selectedSupervisionId += element["id"];
    });
  }

  selectedcustomer2: any = [];
  selectedCustomer2: any;
  selectedCustomerId2: number = 0;
  onCustomerSelect2(item: any) {
    this.selectedCustomer2 = "";
    this.selectedCustomerId2 = 0;
    this.selectedcustomer2.forEach((element) => {
      this.selectedCustomer2 = element["itemName"];
      this.selectedCustomerId2 = element["id"];
    });
  }
  selectedcontractor2: any = [];
  selectedContractor2: any;
  selectedContractorId2: number = 0;
  onContractorSelect2(item: any) {
    this.selectedContractor2 = "";
    this.selectedContractorId2 = 0;
    this.selectedcontractor2.forEach((element) => {
      this.selectedContractor2 = element["itemName"];
      this.selectedContractorId2 = element["id"];
    });
  }
  selectedmaincontractor2: any = [];
  selectedMainContractor2: any;
  selectedMainContractorId2: number = 0;
  onMainContractorSelect2(item: any) {
    this.selectedMainContractor2 = "";
    this.selectedMainContractorId2 = 0;
    this.selectedMainContractor2 = item.itemName;
    this.selectedMainContractorId2 = item.id;
  }
  selectedconsultant2: any = [];
  selectedConsultant2: any;
  selectedConsultantId2: number = 0;
  onConsultantSelect2(item: any) {
    this.selectedConsultant2 = "";
    this.selectedConsultantId2 = 0;
    this.selectedconsultant2.forEach((element) => {
      this.selectedConsultant2 += element["itemName"];
      this.selectedConsultantId2 += element["id"];
    });
  }
  selectedsupervision2: any = [];
  selectedSupervision2: any;
  selectedSupervisionId2: number = 0;
  onSupervisionSelect2(item: any) {
    this.selectedSupervision2 = "";
    this.selectedSupervisionId2 = 0;
    this.selectedsupervision2.forEach((element) => {
      this.selectedSupervision2 += element["itemName"];
      this.selectedSupervisionId2 += element["id"];
    });
  }

  showStage: any = [];
  getstage() {
    let data = {
      Mode: "Add",
    };
    this.UserService.GetStageList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStageArray = res;
        this.showStage = [];
        for (const stageData of this.showStageArray["Data"]) {
          this.showStage.push({
            id: stageData["StageId"],
            itemName: stageData["StageName"],
          });
        }
      } else {
        this.showStageArray = [];
      }
    });
  }
  selectedstage: any = [];
  selectedStage: any;
  selectedStageId: number = 0;
  onStageSelect(item: any) {
    this.selectedStage = "";
    this.selectedStageId = 0;
    this.selectedstage.forEach((element) => {
      this.selectedStage += element["itemName"];
      this.selectedStageId += element["id"];
    });
  }
  selectedstage2: any = [];
  selectedStage2: any;
  selectedStageId2: number = 0;
  onStageSelect2(item: any) {
    this.selectedStage2 = "";
    this.selectedStageId2 = 0;
    this.selectedstage2.forEach((element) => {
      this.selectedStage2 += element["itemName"];
      this.selectedStageId2 += element["id"];
    });
  }

  showProbability: any = [];
  getprobability() {
    let data = {};
    this.UserService.GetInquiryProbabilityList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProbabilityArray = res;
        this.showProbability = [];
        for (const probabilityData of this.showProbabilityArray["Data"]) {
          this.showProbability.push({
            id: probabilityData["InquiryProbabilityId"],
            itemName: probabilityData["Percentage"],
          });
        }
      } else {
        this.showProbabilityArray = [];
      }
    });
  }
  selectedprobability: any = [];
  selectedProbability: any;
  selectedProbabilityId: number = 0;
  onProbabilitySelect(item: any) {
    this.selectedProbability = "";
    this.selectedProbabilityId = 0;
    this.selectedprobability.forEach((element) => {
      this.selectedProbability += element["itemName"];
      this.selectedProbabilityId += element["id"];
    });
  }
  selectedprobability2: any = [];
  selectedProbability2: any;
  selectedProbabilityId2: number = 0;
  onProbabilitySelect2(item: any) {
    this.selectedProbability2 = "";
    this.selectedProbabilityId2 = 0;
    this.selectedprobability2.forEach((element) => {
      this.selectedProbability2 += element["itemName"];
      this.selectedProbabilityId2 += element["id"];
    });
  }

  showQuotationEr: any = [];
  getquotationEr() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showQuotationErArray = res;
        this.showQuotationEr = [];
        for (const quotationErData of this.showQuotationErArray["Data"]) {
          this.showQuotationEr.push({
            id: quotationErData["UserId"],
            itemName: `${quotationErData["UserName"]} (${quotationErData["EmailId"]}) ${quotationErData["EmployeeId"]}`,
          });
        }
      } else {
        this.showQuotationErArray = [];
      }
    });
  }
  selectedquotationEr: any = [];
  selectedQuotationEr: any;
  selectedQuotationErId: number = 0;
  onQuotationErSelect(item: any) {
    this.selectedQuotationEr = "";
    this.selectedQuotationErId = 0;
    this.selectedquotationEr.forEach((element) => {
      this.selectedQuotationEr += element["itemName"];
      this.selectedQuotationErId += element["id"];
    });
  }
  selectedquotationEr2: any = [];
  selectedQuotationEr2: any;
  selectedQuotationErId2: number = 0;
  onQuotationErSelect2(item: any) {
    this.selectedQuotationEr2 = "";
    this.selectedQuotationErId2 = 0;
    this.selectedquotationEr2.forEach((element) => {
      this.selectedQuotationEr2 += element["itemName"];
      this.selectedQuotationErId2 += element["id"];
    });
  }

  showSalesEr: any = [];
  getsalesEr() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showSalesErArray = res;
        this.showSalesEr = [];
        for (const salesErData of this.showSalesErArray["Data"]) {
          this.showSalesEr.push({
            id: salesErData["UserId"],
            itemName: `${salesErData["UserName"]} (${salesErData["EmailId"]}) ${salesErData["EmployeeId"]}`,
          });
        }
      } else {
        this.showSalesErArray = [];
      }
    });
  }
  selectedsalesEr: any = [];
  selectedSalesEr: any;
  selectedSalesErId: number = 0;
  onSalesErSelect(item: any) {
    this.selectedSalesEr = "";
    this.selectedSalesErId = 0;
    this.selectedsalesEr.forEach((element) => {
      this.selectedSalesEr += element["itemName"];
      this.selectedSalesErId += element["id"];
    });
  }
  selectedsalesEr2: any = [];
  selectedSalesEr2: any;
  selectedSalesErId2: number = 0;
  onSalesErSelect2(item: any) {
    this.selectedSalesEr2 = "";
    this.selectedSalesErId2 = 0;
    this.selectedsalesEr2.forEach((element) => {
      this.selectedSalesEr2 += element["itemName"];
      this.selectedSalesErId2 += element["id"];
    });
  }

  businessVertical: any = [];
  getBusinessVertical() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessVerticalArray = res;
        this.businessVertical = [];
        for (const verticalData of this.businessVerticalArray["Data"]) {
          this.businessVertical.push({
            id: verticalData["Id"],
            itemName: verticalData["Name"],
          });
        }
      } else {
        this.businessVerticalArray = [];
      }
    });
  }
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: number = 0;
  onBusinessSelect(item: any) {
    this.selectedBusinessName = "";
    this.selectedBusinessNameId = 0;
    this.selectedBusiness.forEach((element) => {
      this.selectedBusinessName = element["itemName"];
      this.selectedBusinessNameId = element["id"];
    });
  }

  selectedBusiness2: any = [];
  selectedBusinessName2: string = "";
  selectedBusinessNameId2: number = 0;
  onBusinessSelect2(item: any) {
    this.selectedBusinessName2 = "";
    this.selectedBusinessNameId2 = 0;
    this.selectedBusiness2.forEach((element) => {
      this.selectedBusinessName2 = element["itemName"];
      this.selectedBusinessNameId2 = element["id"];
    });
  }

  showReason: any = [];
  getreason() {
    let data = {};
    this.UserService.GetReasonList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showReasonArray = res;
        this.showReason = [];
        for (const reasonData of this.showReasonArray["Data"]) {
          this.showReason.push({
            id: reasonData["ReasonId"],
            itemName: reasonData["ReasonName"],
          });
        }
      } else {
        this.showReasonArray = [];
      }
    });
  }
  selectedreason: any = [];
  selectedReason: any;
  selectedReasonId: number = 0;
  onReasonSelect(item: any) {
    this.selectedReason = "";
    this.selectedReasonId = 0;
    this.selectedreason.forEach((element) => {
      this.selectedReason += element["itemName"];
      this.selectedReasonId += element["id"];
    });
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  onSubmit(value: any) {
    let mode = value;
    if (this.activitytype == "activity") {
      this.submitted = true;
      if (this.registerForm1.valid) {
        this.isDisabled = true;
        this.spinner.show();
        if (
          this.registerForm1.value.ReceivedDate &&
          this.registerForm1.value.ReceivedDate != ""
        ) {
          this.ReceivedDate = moment(
            this.registerForm1.value.ReceivedDate,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
        }
        let data = {
          InquiryId: this.InquiryId,
          InquiryName: this.registerForm1.value.InquiryName,
          ProjectId: this.selectedProjectId,
          CustomerName: this.selectedCustomerId,
          MEPContractor: this.selectedContractorId,
          MainContractor: this.selectedMainContractorId,
          DesignConsultant: this.selectedConsultantId,
          SupervisionConsultant: this.selectedSupervisionId,
          StageId: this.selectedStageId,
          InquiryProbability: this.selectedProbabilityId,
          ReceivedDate: this.ReceivedDate,
          QuotationEngineerId: this.selectedQuotationErId,
          SalesEngineerId: this.selectedSalesErId,
          BusinessVertical: this.selectedBusinessNameId,
          CreatedBy: this.id,
        };
        this.UserService.AddUpdateInquiry(data).subscribe(
          (res) => {
            if (res["result"] == "success") {
              this.spinner.hide();
              this.toastrService.success("Inquiry saved successfully");
              let inquiryId = res["Data"]["InquiryId"];
              let encryptinquiryid = this.encryptData(inquiryId);
              this.createdInquiryId = localStorage.setItem(
                "createdInquiryId",
                encryptinquiryid
              );
              encryptinquiryid = encryptinquiryid
                .toString()
                .replace("=", "Ar1t")
                .replace("/", "FGH")
                .replace("+", "THD");
              if (mode == "save") {
                this.router.navigate([
                  "/inquiry/editinquiry/",
                  encryptinquiryid,
                ]);
              } else {
                this.router.navigate([
                  "/inquiry/detailinquiry-editproduct/",
                  encryptinquiryid,
                ]);
              }
            } else if (res["result"] == "Failed") {
              this.toastrService.error(res["Msg"]);
              this.spinner.hide();
            } else {
              this.toastrService.error(res["Message"]);
              this.spinner.hide();
            }
            this.isDisabled = false;
            this.submitted = false;
          },
          (err) => {
            this.spinner.hide();
            if (err && (err.Msg || err.Message)) {
              this.toastrService.error(err.Msg || err.Message);
            }
          }
        );
      }
    }

    if (this.activitytype == "generalActivity") {
      this.submitted = true;
      if (this.registerForm2.valid) {
        this.isDisabled = true;
        this.spinner.show();
        if (
          this.registerForm2.value.ReceivedDate2 &&
          this.registerForm2.value.ReceivedDate2 != ""
        ) {
          this.ReceivedDate2 = moment(
            this.registerForm2.value.ReceivedDate2,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
        }
        let data2 = {
          ProjectName: this.registerForm2.value.ProjectName,
          ProjectSource: this.selectedProjectSourceId,
          Territory: this.selectedTerritoryId,
          InquiryId: this.InquiryId,
          InquiryName: this.registerForm2.value.InquiryName,
          CustomerName: this.selectedCustomerId2,
          MEPContractor: this.selectedContractorId2,
          MainContractor: this.selectedMainContractorId2,
          DesignConsultant: this.selectedConsultantId2,
          SupervisionConsultant: this.selectedSupervisionId2,
          StageId: this.selectedStageId2,
          InquiryProbability: this.selectedProbabilityId2,
          ReceivedDate: this.ReceivedDate2,
          QuotationEngineerId: this.selectedQuotationErId2,
          SalesEngineerId: this.selectedSalesErId2,
          BusinessVertical: this.selectedBusinessNameId2,
        };
        this.UserService.AddProjectInquiry(data2).subscribe(
          (res) => {
            if (res["result"] == "success") {
              this.spinner.hide();
              this.toastrService.success("Inquiry saved successfully");
              let inquiryId = res["Data"]["InquiryId"];
              let encryptinquiryid = this.encryptData(inquiryId);
              this.createdInquiryId = localStorage.setItem(
                "createdInquiryId",
                encryptinquiryid
              );
              encryptinquiryid = encryptinquiryid
                .toString()
                .replace("=", "Ar1t")
                .replace("/", "FGH")
                .replace("+", "THD");
              if (mode == "save") {
                this.router.navigate([
                  "/inquiry/editinquiry/",
                  encryptinquiryid,
                ]);
              } else {
                this.router.navigate([
                  "/inquiry/detailinquiry-editproduct/",
                  encryptinquiryid,
                ]);
              }
            } else if (res["result"] == "Failed") {
              this.toastrService.error(res["Msg"]);
            } else {
              this.toastrService.error(res["Message"]);
            }
            this.isDisabled = false;
            this.spinner.hide();
            this.submitted = false;
          },
          (err) => {
            this.spinner.hide();
            if (err && (err.Msg || err.Message)) {
              this.toastrService.error(err.Msg || err.Message);
            }
          }
        );
      }
    }
  }

  encryptData(data) {
    try {
      if (data) {
        return CryptoJS.AES.encrypt(
          JSON.stringify(data),
          "1234509876encryptdecrypt1234567890"
        ).toString();
      }
    } catch (e) {}
  }
  //End encrypt Data(n)

  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        data,
        "1234509876encryptdecrypt1234567890"
      );
      if (bytes.toString()) {
        if (CryptoJS.enc.Utf8) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
      }
      if (data) {
        return data;
      }
    } catch (e) {}
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  cleardate() {
    this.registerForm1.get("ReceivedDate").setValue("");
  }

  cleardate2() {
    this.registerForm2.get("ReceivedDate2").setValue("");
  }
}
